import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MyFamilyFirstBooking from '../../../../common/myFamilyFirstBookings'
import SearchBar from '../../../../common/commonSearchBar';
import MyFamilyFirstMoreInfoModal from '../../myFamilyFirst/myFamilyFirstMoreInfoModal';
import Pagination from '../../../../common/pagination';
import * as AnniversaryAction from '../../../../actions/anniversaryAction'
import ClosedModal from '../closeRequestModal';
import { closeRequestInputVal } from '../../../../actions/holidayRequestAction';



const Confirmed = ({status}) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [ searchVal, setSearchVal ] = useState('');
   const [averageOrderValue,setAverageOrderValue]=useState()
    const[totalOrderValue,setTotalOrderValue]=useState()
  
    const [page, setPage] = useState(1);
    const[id,setId]=useState()
    const[statuschange,setStatuschange]=useState()
    const [confirmedMoreInfoModalData, setConfirmedMoreInfoModalData] = useState({});
    const anniversaryConfirmedData = useSelector(state => state.anniversary?.anniversaryConfirmed?.results);
    const totalPage = useSelector(state => state.anniversary?.anniversaryConfirmed?.total_pages);
    const START_DATE = useSelector(state => state.anniversary.startDate);
    const END_DATE = useSelector(state => state.anniversary.endDate);
    const SEARCH_TERM = useSelector(state => state.anniversary.searchTerm);
    const PAGE_NO = useSelector(state => state.anniversary.pageNo);
    const [requestModal, setRequestModal] = useState(false);
    console.log(requestModal);
    const [closeRequestModalData, setCloseRequestModalData] = useState({});
    const [isclosingMessageBool, setIsclosingMessageBool] = useState(null);
    const closeRequestMessage = useSelector(state => state.holidayRequest.closeRequestMsg);

    useEffect(() => {
       
        let value = [];
        anniversaryConfirmedData?.map((elem) => {
          if (elem.price) {
            value.push(elem.price)
         
          }
        
        },);
        const valueSum=value.reduce((acc,elem)=>{
            return acc+elem
    
        },0)
        setTotalOrderValue(valueSum)
        setAverageOrderValue(Math.round(valueSum/anniversaryConfirmedData?.length));
      }, [anniversaryConfirmedData]);

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => document.body.style.overflow = 'unset';
    }, [showModal]);
    useEffect(() => {
        setPage(1)
      }, [status])
    const handleMoreInfoClick = (data) => {
        setShowModal(true);
        setConfirmedMoreInfoModalData(data);
    };

    const requestStatusChange = (event, id,data) => {
        setCloseRequestModalData(data)
        let status = event.target.value;
        setId(id)
        statuschange(status)
     
        console.log(status);
        if(status === "cancelled")setRequestModal(true);
        else{

            dispatch(AnniversaryAction.anniversaryRequestStatusChange(status, id,null, refereshList))
        }

    };
    const refereshList = () => {
        dispatch(AnniversaryAction.getAnniversaryRequested(1));
        dispatch(AnniversaryAction.getAnniversaryPlanning(1));
        dispatch(AnniversaryAction.getAnniversaryConfirmed(page));
        dispatch(AnniversaryAction.getAnniversaryCancelled(1));
    };

    const handlePagination = (e, value) => {
        setPage(value);
        dispatch(AnniversaryAction.setPageNo(value))
        if (SEARCH_TERM || START_DATE || END_DATE) {
            dispatch(AnniversaryAction.searchAnniversaryRequests(SEARCH_TERM, START_DATE, END_DATE, "confirmed", value));
        } else {
            dispatch(AnniversaryAction.getAnniversaryConfirmed(value));
        }
    };

    const handleChange = (event) => {
        if (event.target.value) {
            dispatch(AnniversaryAction.searchAnniversaryRequests(event.target.value, START_DATE, END_DATE, "confirmed", PAGE_NO));
        } else {
            dispatch(AnniversaryAction.getAnniversaryConfirmed(1));
            setPage(1);
        }
        dispatch(AnniversaryAction.setSearchTerm(event.target.value))
    };
    const closeRequestHandler = () => {
 
        setIsclosingMessageBool(false)
        if(closeRequestMessage === "")setIsclosingMessageBool(true)
        else {
            dispatch(AnniversaryAction.anniversaryRequestStatusChange(statuschange, id, closeRequestMessage,refereshList))
          setRequestModal(false)
        }
        dispatch(closeRequestInputVal(''));
      };
    
    const notToCancel=()=>{
        setRequestModal(false)
        setIsclosingMessageBool(false);
    
    }

    const anniversaryConfirmedDisplayData = anniversaryConfirmedData && anniversaryConfirmedData.map((data) => (
        <MyFamilyFirstBooking
            locationsPreferred={data.locations_preferred}
            occasion={data.occasion}
            requestedBy={`Requested by ${data.contact_name}`}
            email={data.contact_email}
            contactNum={data.contact_number}
            messageTitle={data.specific_request ? data.specific_request : 'No Message'}
            specialRequest={data.specific_request ? data.specific_request : "N/A"}
            onClick={() => handleMoreInfoClick(data)}
            myFamilyFirstStatusChange={requestStatusChange}
            isConfirmed={true}
            data={data}
            id={data.id}
            refCode={data.ref_id ? `#${data.ref_id}` : "No ref id"}
            value={data.status}
        />
    ));

    return (
        <>
            <SearchBar
                searchVal={SEARCH_TERM}
                handleChange={handleChange}
            />
            {anniversaryConfirmedData && anniversaryConfirmedData?.length === 0 &&
                <div className="enquiry-card-holder">No Record Found!</div>
            }
      <p style={{display:"flex",}}><span><b>Total Order Value: {" "} {totalOrderValue} </b> </span>

<span style={{marginLeft:"80px"}}><b> 
Average Order Value: {" "} {averageOrderValue}
</b>
  </span></p>
            {anniversaryConfirmedDisplayData}
            <MyFamilyFirstMoreInfoModal
                open={showModal}
                close={() => setShowModal(false)}
                modalData={confirmedMoreInfoModalData}
                section={"Anniversary Requested"}
                isCancellationMessage={false}
            />
            <Pagination
                totalPage={totalPage}
                page={page}
                onChange={(event, value) => handlePagination(event, value)}
            />
              {requestModal && 
                <ClosedModal 
                  open={requestModal}
                  handleClose={notToCancel}
                  data={closeRequestModalData}
                  isclosingMessage={isclosingMessageBool}
                  closeRequestHandler={closeRequestHandler}
                />
              }
        </>
    );
};

export default Confirmed;
